type FacebookLoginResponse = {
  status: 'connected' | string;
  authResponse?: {
    accessToken: string;
  };
};

export const getLoginStatus = () => {
  return new Promise((resolve, reject) => {
    // @ts-ignore
    window?.FB?.getLoginStatus((response: any) => {
      resolve(response);
    });
  });
};
export const fbLogin = async (): Promise<FacebookLoginResponse> => {
  return new Promise((resolve, reject) => {
    // @ts-ignore
    window?.FB?.login(
      (response: any) => {
        if (response.status === 'connected') {
          resolve(response);
        } else {
          reject(response);
        }
      },
      {
        config_id: '552072867547214',
      },
    );
  });
};
